import {EnhancedMenu} from '~/lib/utils';
import {Text} from '~/components';
import {Drawer} from './Drawer.client';
import {Link} from '@shopify/hydrogen';
import {Suspense} from 'react';
import {Footer} from './Footer.client';
export function MenuDrawer({
  isOpen,
  onClose,
  menu,
  collectionsMenu,
  footerMenu,
}: {
  isOpen: boolean;
  onClose: () => void;
  menu: EnhancedMenu;
  collectionsMenu: EnhancedMenu;
  footerMenu: EnhancedMenu;
}) {

  return (
    <Drawer open={isOpen} onClose={onClose} openFrom="left" heading="">
      <div className="flex justify-between relative flex-col h-full p-6">
        <MenuMobileNav
          collectionsMenu={collectionsMenu}
          menu={menu}
          onClose={onClose}
        />

        <Suspense fallback={<Footer />}>
          <Footer onClose={onClose} menu={footerMenu} />
        </Suspense>
      </div>
    </Drawer>
  );
}

export const getUrl = (url) => {
  // 1) strip protocol + domain
  let path = url.replace(/^https?:\/\/gauntlettcheng\.com/, '')

  // 2) /blogs/ → /collections/
  if (path.startsWith('/blogs/')) {
    return path.replace(/^\/blogs\//, '/collections/')
  }

  // 3) /collections/ → /shop/
  if (path.startsWith('/collections/')) {
    return path.replace(/^\/collections\//, '/shop/')
  }

  // 4) fallback: return whatever’s left
  return path
}

function MenuMobileNav({
  menu,
  collectionsMenu,
  onClose,
}: {
  menu: EnhancedMenu;
  collectionsMenu: EnhancedMenu;
  onClose: () => void;
}) {
  return (
    <div className='grid grid-cols-2'>
       <nav className='flex flex-col'> 
      <Link to="/collections" onClick={onClose}>
          Collections
        </Link>
        <br />
        {(collectionsMenu?.items || []).map((item) => (
          <Link
            key={item.id}
            to={getUrl(item.to)}
            // target={item.target}
            onClick={onClose}
            data-to={item.to}
          >
            <Text as="span" size="copy">
              {item.title}
            </Text>
          </Link>
        ))}
      </nav>

      <nav className="flex flex-col">
        {/* Top level menu items */}
        <Link to="/" onClick={onClose}>
          Shop
        </Link>
        <br />
        
        {(menu?.items || []).map((item) => (
          <Link
            key={item.id}
            to={getUrl(item.to)}
            target={item.target}
            onClick={onClose}
          >
            <Text as="span" size="copy">
              {item.title}
            </Text>
          </Link>
        ))}
      </nav>
 
     
    </div>
  );
}
